import React, { useRef, useState, useEffect, useCallback } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { FiLoader } from 'react-icons/fi';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

import * as Yup from 'yup';
import { Form } from '@unform/web';
import { BsFilterLeft, BsFilter } from 'react-icons/bs';
import { Input } from '~/components/Forms';

import {
  PageContainer,
  TableHeader,
  LimiterInputWidth,
} from '~/styles/components';

import Aside from '~/components/Aside';
import { Button } from '~/components/global';

import { Container, Wrap, WrapButtons, TitleForm, Options } from './styles';

import ApiClient from '~/utils/ApiClient';
import { showModalMessage } from '~/services/notification';
import buildQueryPackageFilters from '~/functions/buildQueryPackageFilters';
import ListaPageCienciaFilmagem from '~/components/Admin/Home/ListaPageCienciaFilmagem';
import WhiteBox from '~/components/WhiteBox';
import Option from '~/components/Option';

export const selectCustomStyles = {
  option: provided => ({
    ...provided,
    borderBottom: `1px #ddd solid`,
    color: '#828282',
    backgroundColor: '#ffffff',
    padding: 16,
    fontFamily: 'PoppinsSemiBold',
    fontSize: 14,
    boxSizing: 'border-box',
    outline: 'none',
  }),
  input: provided => ({
    ...provided,
    padding: 16,
    fontSize: 14,
    margin: 0,
  }),
  container: provided => ({
    ...provided,
    padding: 0,
    marginBottom: 15,
  }),
  valueContainer: provided => ({
    ...provided,
    padding: 0,
  }),
  placeholder: provided => ({
    ...provided,
    marginLeft: 16,
    fontSize: 14,
    padding: 0,
    fontFamily: 'PoppinsSemiBold',
  }),
  control: provided => ({
    ...provided,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#d0d0d0',
    borderRadius: 2,
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
    boxShadow: '0 3px 12px rgba(0, 0, 0, 0.075)',
    height: 48,
    outline: 'none',
  }),
  singleValue: provided => ({
    ...provided,
    marginLeft: 16,
    fontSize: 14,
    color: '#828282',
  }),
  indicatorsContainer: provided => ({
    ...provided,
    fontSize: 10,
  }),
};

function CienciaFilmagem() {
  const formRef = useRef();

  const [searchFormData, setSearchFormData] = useState({});
  const [item, setItem] = useState(0);
  const [show, setShow] = useState(false);
  const [page, setPage] = useState(1);
  const [totPage, setTotPage] = useState(1);
  const [hiddenButton, setHiddenButton] = useState(true);
  const [cienciaFilmagemList, setCienciaFilmagemList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState('');
  const location = useLocation();
  const dadoState = location.state;

  const [cienciaStatusList, setCienciaStatusList] = useState([
    { label: 'Carregando...', value: '' },
  ]);

  // --- pagination --- inicio
  const handleChangePaginator = (event, value) => {
    setPage(value);
  };

  const useStyles = makeStyles(theme => ({
    root: {
      '& > *': {
        marginTop: theme.spacing(2),
      },
    },
  }));

  function handleChange(e) {
    const { name, value, checked, type } = e.target;

    setSearchFormData(state => ({
      ...state,
      [name]: {
        value: type === 'checkbox' ? checked : value,
        filterName: e.target?.getAttribute('filterName'),
        filterOperator: e.target?.getAttribute('filterOperator'),
      },
    }));
  }

  function BasicPagination() {
    const classes = useStyles();
    return (
      <div className={classes.root}>
        <Pagination
          count={totPage}
          page={page}
          onChange={handleChangePaginator}
        />
      </div>
    );
  }
  // --- pagination --- fim

  const renderTabs = useCallback(async () => {
    try {
      setLoading(true);

      const result = await ApiClient.doRequest({
        uri: `ciencia-filmagem-status`,
        method: ApiClient.GET,
        expectedStatus: 200,
      });

      const cienciaStatusResp = result.data.data;

      setCienciaStatusList(
        cienciaStatusResp.map(({ uuid, name }) => ({
          label: name,
          value: uuid,
        })),
      );

      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    renderTabs();
  }, [renderTabs]);

  const renderCienciaFilmagem = useCallback(async () => {
    try {
      setLoading(true);
      let dataList = [];

      const status =
        cienciaStatusList[item]?.value || cienciaStatusList[item]?.label;

      const result = await ApiClient.doRequest({
        uri: `ciencia-filmagem-interna?order[id]=desc&page=${page}&filters[][ciencia_filmagem_status.uuid@equal]=${status}`,
        method: ApiClient.GET,
        expectedStatus: 200,
      });

      const responseCiencia = result?.data?.data;

      dataList = responseCiencia.map(cienciaFilmagemInterna => ({
        ...cienciaFilmagemInterna,
        name: cienciaFilmagemInterna?.titulo_obra,
        uuid: cienciaFilmagemInterna?.uuid,
      }));

      setTotPage(result.data?.last_page);
      setCienciaFilmagemList(dataList);
    } catch (e) {
      await showModalMessage({
        type: 'error',
        text: 'Não foi possível listar as filmagens.',
      });
    } finally {
      setLoading(false);
    }
  }, [cienciaStatusList, item, page]);

  const handleSubmit = useCallback(
    async _ => {
      try {
        formRef.current.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().test(
            'nome-informado',
            'Informe ao menos 3 caracteres para buscar',
            value => !(value && value?.length < 3),
          ),
        });

        await schema.validate(searchFormData, {
          abortEarly: false,
        });

        setFilters(buildQueryPackageFilters(searchFormData));
      } catch (err) {
        const validationErrors = {};
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach(error => {
            validationErrors[error.path] = error.message;
          });
          formRef.current.setErrors(validationErrors);
        }
      }
    },
    [searchFormData],
  );

  function renderList() {
    if (loading) {
      return <FiLoader size={20} className="icon-spin" />;
    }

    if (!loading && cienciaFilmagemList.length <= 0) {
      return 'Nenhum registro encontrado';
    }

    return (
      <>
        {cienciaFilmagemList.map(lista => (
          <ListaPageCienciaFilmagem
            key={lista.uuid}
            data={lista}
            cienciaStatusList={cienciaStatusList}
            loadCiencia={renderCienciaFilmagem}
          />
        ))}
      </>
    );
  }
  function handleResetSearchFields() {
    setFilters('');
    setSearchFormData({
      data_filmagem: { value: '' },
      titulo_obra: { value: '' },
    });
  }

  useEffect(() => {
    renderCienciaFilmagem();
  }, [renderCienciaFilmagem]);

  return (
    <PageContainer>
      <Aside />
      <Container>
        <Wrap>
          <TitleForm>
            <h4>Ciência de Filmagem Interna</h4>
          </TitleForm>
        </Wrap>
        <Options>
          {cienciaStatusList.map(cienciaStatus => (
            <Option
              active={item === cienciaStatusList.indexOf(cienciaStatus)}
              onClick={() => {
                setPage(1);
                setItem(cienciaStatusList.indexOf(cienciaStatus));
              }}
            >
              {cienciaStatus.label}
            </Option>
          ))}
        </Options>
        <WhiteBox column maxHeight>
          <>
            {hiddenButton === true && (
              <span tooltip="Exibir filtro!">
                <button
                  type="button"
                  onClick={() => {
                    setShow(true);
                    setHiddenButton(false);
                  }}
                >
                  <BsFilterLeft color="#000" size={24} />
                </button>
              </span>
            )}

            {show === true && (
              <Form ref={formRef} onSubmit={handleSubmit}>
                <Wrap>
                  <LimiterInputWidth w25>
                    <Input
                      type="date"
                      name="data_filmagem"
                      label="Data de Criação"
                      value={searchFormData.data_filmagem?.value}
                      onChange={handleChange}
                    />
                  </LimiterInputWidth>
                  {/* <LimiterInputWidth w25>
                    <Input
                      type="text"
                      name="work_type_id"
                      filterOperator="equal"
                      label="ID"
                      value={searchFormData.work_type_id?.value}
                      onChange={handleChange}
                 />
                 </LimiterInputWidth> */}
                  <LimiterInputWidth w50>
                    <Input
                      type="text"
                      name="titulo_obra"
                      filterName="titulo_obra.name"
                      label="Nome"
                      value={searchFormData.titulo_obra?.value}
                      onChange={handleChange}
                    />
                  </LimiterInputWidth>
                </Wrap>
                <Wrap>
                  <LimiterInputWidth w50>
                    <WrapButtons>
                      <Button
                        type="submit"
                        btType="#26A2B1"
                        label="Buscar"
                        full
                        width="170px"
                      />
                      <Button
                        btType="#707683"
                        onClick={handleResetSearchFields}
                        label="Limpar"
                        full
                        width="100px"
                      />
                      <span tooltip="Ocultar filtro!">
                        <button
                          type="button"
                          onClick={() => {
                            setShow(false);
                            setHiddenButton(true);
                          }}
                        >
                          <BsFilter color="#000" size={24} />
                        </button>
                      </span>
                    </WrapButtons>
                  </LimiterInputWidth>
                </Wrap>
              </Form>
            )}
          </>
          <table>
            <TableHeader>
              <tr>
                <th>Data de Criação</th>
                <th>Nome da Obra</th>
                <th style={{ justifyContent: 'center' }}>Produtora</th>
                <th style={{ justifyContent: 'center' }}>CPF/CNPJ</th>
                <th style={{ justifyContent: 'center' }}>Solicitante</th>
                <th style={{ justifyContent: 'center' }}>E-mail Solicitante</th>
                <th style={{ justifyContent: 'center' }}>Ações</th>
              </tr>
            </TableHeader>

            <WhiteBox column aCenter>
              <tbody>{renderList()}</tbody>
              <BasicPagination />
            </WhiteBox>
          </table>
        </WhiteBox>
      </Container>
    </PageContainer>
  );
}

export default withRouter(CienciaFilmagem);
